<!-- not found -->
<template>
  <div id='notFoundPage'>
    this is not found
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  components: {},
  created () {},
  methods: {}
}
</script>
<style scoped>

</style>
